import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  // successAlert: {
  //   color: theme.palette.common.white,
  //   backgroundColor: theme.palette.common.black,
  // },
  // errorAlert: {
  //   color: theme.palette.common.white,
  //   backgroundColor: theme.palette.error.main,
  // },
  // marginTop: {
  //   marginTop: '20px',
  // },
  // errorIcon: {
  //   color: theme.palette.common.white,
  // },
}));

export default useStyles;
